import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './aboutUsPage.css'; // Make sure to import the CSS file
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import '../home/homePage.css';
import { useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';
import aboutUsMob from "../../assets/images/about_us_mob.png";
import aboutUsWeb from "../../assets/images/about_us_web.jpg";
import planetMob from "../../assets/images/planet_mob.png";
import planetWeb from "../../assets/images/planet_web.png";

interface AboutUsItem {
    block_id: number;
    code: string;
    title: string;
    html_content: string;
    is_active: number;
}

const AboutUsPage = () => {
    const [upperColumnData, setUpperColumnData] = useState<AboutUsItem[]>([]);
    const [middleColumnData, setMiddleColumnData] = useState<AboutUsItem[]>([]);
    const [upperImageContainer, setUpperImageContainerData] = useState<AboutUsItem[]>([]);
    const [lowerImageContainer, setLowerImageContainerData] = useState<AboutUsItem[]>([]);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
    const demoUrl = process.env.REACT_APP_DEMO_FRONT_URL
    const demoUrlConst = `${demoUrl}globHand.png`
    const navigate = useNavigate();
    const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage } =
        useUser();
    const { fetchCartQuantity, cartQuantity, setCartQuantity, handleQuantity } = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId, fetchCsrfToken } = useUser();


    const fetchData = async (code: string, setter: React.Dispatch<React.SetStateAction<AboutUsItem[]>>) => {
        try {
            const response = await fetch(`${backendUrl}${version}All-tempelate/${code}`,
                {
                    method: 'GET',
                    headers: {
                        // Accept:'aplication/json',
                        "Content-Type": "application/json",

                    },
                    credentials: "include",
                    mode: "cors"


                });
            const data = await response.json();
            //console.log(`Fetched Data for code ${code}:`, data); // Log the data to inspect its structure

            if (Array.isArray(data.data)) {
                setter(data.data);
            } else {
                // console.warn(`Expected data to be an array but received for code ${code}:`, data);
                setter([]); // Default to empty array if not an array
            }
        } catch (error) {
            //console.error(`Error fetching data for code ${code}:`, error);
            setter([]); // Default to empty array in case of error
        }
    };

    useEffect(() => {
        fetchData('about_us_introduct', setUpperColumnData);
        fetchData('about_us_page', setMiddleColumnData);
        fetchData('about_us_rside_banner_1', setUpperImageContainerData);
        fetchData('about_us_rside_banner_2', setLowerImageContainerData);
        fetchSeoMetaDetails()
    }, []);


    const fetchSeoMetaDetails = async () => {
        try {
            const code = 'about_us_page'
            const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`, {
                method: 'GET',
                headers: {
                    // Accept:'aplication/json',
                    "Content-Type": "application/json",

                },
                credentials: "include",
                mode: "cors"

            });
            if (!response.ok) throw new Error('Failed to fetch categories');
            const data = await response.json();

            await changeTitleAndMetaTags(data.result.page_title, { description: data.result.meta_description, keywords: data.result.meta_tag });
        } catch (error) {
            //console.error('Error fetching categories:', error);
        }
    };

    const changeTitleAndMetaTags = async (
        title: string,
        metaTags: { description?: string; keywords?: string;[key: string]: string | undefined }
    ) => {
        try {
            // Update the document title
            if (title) {
                document.title = title;
            } else {
                document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            }

            // Update or create meta tags
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    // Update existing meta tag
                    metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
                } else {
                    // Create new meta tag if it doesn't exist
                    const newMetaTag = document.createElement('meta');
                    newMetaTag.name = metaName;
                    newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                    document.head.appendChild(newMetaTag);
                }
            });

            // Cleanup function to reset the title and meta tags when unmounting
            return () => {
                document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
                Object.keys(metaTags).forEach((metaName) => {
                    const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                    if (metaTag) {
                        metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                    }
                });
            };
        } catch (error) {
            //console.error("Error updating title and meta tags:", error);
        }
    };

    useEffect(() => {
        const isSessionHandled = sessionStorage.getItem("sessionHandled");

        // If the session was already handled, avoid running this logic again
        if (isSessionHandled) return;

        // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());

        if (checkSessionTokenExpirationStatus()) {
            // Clear session-related operations
            handleQuantity();
            handleRemoveLocalStorage();

            // Set the sessionHandled flag to true to prevent re-execution after reload
            sessionStorage.setItem("sessionHandled", "true");

            // Redirect to the homepage
            navigate("/");

            // Reload the page to clear cache
            window.location.reload();
        }
    }, []);


    return (
        <div>
            <Header />
            <main className="main-content-about-us-page">
                <div className='container'>
                    <div className="section_breadcrumb">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 ps-0">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="/">Home</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <a >About us</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="about">
        <div className="container">
            <div className="row">
                <h1 className="about_heading text-center"> Sell Used Electronics The Smart Way</h1>
                <div className="about_banner web"><img className="img-fluid w-100" src={aboutUsWeb} alt="about_banner"/></div>
                <div className="about_banner mob"><img className="img-fluid w-100" src={aboutUsMob} alt="about_banner_mob"/></div>
                <h2 className="about_sub_heading">Where do your old electronics go after you replace them? </h2>
                <p className="fs-18">At Selsmart, we ensure they do not gather dust or end up in landfills. Instead, we turn
                    them into
                    opportunities—for you to earn money and for the planet to benefit. </p>
                <p className="fs-18">Selsmart, powered by Attero, India’s largest e-waste and EV battery recycler, changes
                    how e-waste is
                    managed. We collect your used or old electronics from your doorstep and recycle them responsibly,
                    helping to reduce pollution and address climate change. </p>
                <h2 className="about_sub_heading">The Impact You Make</h2>
                <p className="fs-18">Recycling just one air conditioner, refrigerator, or washing machine reduces CO₂
                    emissions equivalent to planting 50 trees or powering a home for several months.   </p>
                <p className="fs-18">With 1,478,047 kg of e-waste recycled so far, we have reduced CO₂ emissions equal to
                    removing thousands of cars from the road. </p>

                    <h2 className="about_sub_heading" style={{ marginBottom: '10px' }}>
    Let Your Old Electronics Leave a Greener Footprint
</h2>

                <h3 className="fs-28_heading">Selsmart for the Planet </h3>
                <div className="planet_img web"><img className="img-fluid w-100" src={planetWeb}/></div>
                <div className="planet_img mob"><img className="img-fluid w-100" src={planetMob}/></div>

                <h2 className="fs-28_heading">Join the Change</h2>
                <p className="fs-18">Building a better planet for future generations begins with small actions. Recycling
                    old electronics the right way makes a significant difference. Choose Selsmart, backed by Attero’s
                    15+ years of expertise, to turn your old electronics into a step toward a sustainable future. </p>
                <p className="selsmart_quote">Don’t just sell it—Selsmart it! </p>
            </div>
        </div>
    </section>
                </div>

            </main>
            <Footer />
        </div>
    );
};

export default AboutUsPage;
